import httpClient from "./httpClient";

export const indianTrademarkApi = {
  list: (params) => httpClient.get("/indian-trademarks", { params }),
  getOne: (id) => httpClient.get(`/indian-trademarks/${id}`),

  /**
   * Not an axios call — this is a direct URL for an <img src>, served by a
   * route that's deliberately not behind auth (a plain <img> tag can't
   * send the Authorization header this API otherwise requires). See
   * server/routes/indianTrademarkRoutes.js.
   */
  logoUrl: (id) =>
    `${httpClient.defaults.baseURL}/indian-trademarks/${id}/logo`,
};
